/**
 * Identity Platform (Firebase Auth) client for the Outlook task pane.
 *
 * The task pane is a full Chromium React SPA, so it signs in with the Firebase
 * Web SDK exactly like the aira-email admin does, and sends the resulting ID
 * token as `Authorization: Bearer` to the RAG backend (which verifies it via
 * firebase-admin `verifyIdToken`). VITE_IDP_WEB_API_KEY is a public identifier
 * (safe to embed); it only scopes REST calls to the Identity Platform project.
 */
import { type FirebaseApp, initializeApp } from 'firebase/app';
import { type Auth, getAuth } from 'firebase/auth';
import { getIdpConfig } from './runtimeConfig';

let app: FirebaseApp | undefined;
let auth: Auth | undefined;

export function getFirebaseAuth(): Auth {
  if (auth) return auth;

  const { projectId, apiKey } = getIdpConfig();

  app = initializeApp({
    apiKey,
    authDomain: `${projectId}.firebaseapp.com`,
    projectId,
  });
  auth = getAuth(app);
  return auth;
}
